import {register} from '../vendor/theme-scripts/theme-sections';
import accordion from '../features/accordion';
import popoutSection from '../features/popout';
import collectionFiltersForm from '../features/collection-filters-form';
import {swatchGridSection} from '../features/swatch';
import {tooltipSection} from '../features/tooltip';
import collectionFiltersSidebar from '../features/collection-filters-sidebar';

register('search-page', [popoutSection, collectionFiltersSidebar, collectionFiltersForm, swatchGridSection, tooltipSection, accordion]);
